/******
 *
 * formulas used
 *revenue growth y/y=((current year revenue -previous year revenue)/previous year total revenue)*100
 * operating expense y/y=((current year opEx -previous year opEx)/previous year total opEx)*100
 * using income details
 */

import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import {
  Box,
  createTheme,
  Stack,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import ViewListIcon from "@mui/icons-material/ViewList";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  mode: "dark",
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
    fontSize: 12,
    fontFamily: "public sans",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    fontFamily: "public sans",
  },
}));

const GrowthChart = ({ incomeDetails, mode, financialPeriod }) => {
  const [dataView, setDataView] = useState(false);
  const [growthData, setGrowthData] = useState();
  const [timePeriods, setTP] = useState([]);
  const [revenueGrowth, setRG] = useState([]);
  const [opExpenseGrowth, setOpExG] = useState([]);

  useEffect(() => {
    // console.log("income details", incomeDetails);
    if (financialPeriod == "quarterly") {
      //   if (incomeDetails?.quarterly?.income?.length > 0) {
      //     // // console.log("trueeeeeeeeeeeee");
      //     let data = incomeDetails?.quarterly?.income?.map((i) => {
      //       return {
      //         fiscalPeriod: `FY${i?.fiscalYear - 2000} Q${i?.fiscalQuarter}`,
      //         profitMargin: i?.netIncome / i?.totalRevenue,
      //         operatingMargin: i?.operatingIncome / i?.totalRevenue,
      //         grossMargin: i?.grossProfit / i?.totalRevenue,
      //       };
      //     });
      //     let temp = [];
      //     // // console.log("d=>", data);
      //     for (let i = 15; i >= 0; i--) {
      //       temp?.push(data[i]);
      //     }
      //     setTP(temp.map((t) => t?.fiscalPeriod));
      //     setGM(temp.map((t) => t?.grossMargin.toFixed(2)));
      //     setPM(temp.map((t) => t?.profitMargin.toFixed(2)));
      //     setOM(temp.map((t) => t?.operatingMargin.toFixed(2)));
      //     // // console.log("data>", temp);
      //     setRAndIData(temp);
      //   }
      if (incomeDetails?.quarterly?.income?.length > 0) {
        // // console.log("income details", incomeDetails?.quarterly);
        // console.log("trueeeeeeeeeeeee");
        let incDet = incomeDetails?.quarterly?.income;

        // console.log(
        //   "2006-2007 difference",
        //   ((incDet[14]?.totalRevenue - incDet[15]?.totalRevenue) /
        //     incDet[16 - 1]?.totalRevenue) *
        //     100
        // );
        let temp = [];
        let i = incDet?.length - 1;
        while (i > 0) {
          // console.log("i", i, incDet[i]?.fiscalYear, incDet[i - 1]?.fiscalYear);
          temp.push({
            fiscalPeriod: `FY${incDet[i - 1]?.fiscalYear - 2000} Q${
              incDet[i - 1]?.fiscalQuarter
            }`,
            revenueGrowth:
              ((incDet[i - 1]?.totalRevenue - incDet[i]?.totalRevenue) /
                incDet[i]?.totalRevenue) *
              100,
            operatingExpenseGrowth:
              ((incDet[i - 1]?.operatingExpense - incDet[i]?.operatingExpense) /
                incDet[i]?.operatingExpense) *
              100,
          });

          i = i - 1;
        }
        // console.log("lat Arr", temp);

        setTP(temp.map((t) => t?.fiscalPeriod));
        setRG(temp.map((t) => t?.revenueGrowth.toFixed(2)));
        setOpExG(temp.map((t) => t?.operatingExpenseGrowth.toFixed(2)));

        // // console.log("data>", temp);
        setGrowthData(temp);
      }
    } else {
      if (incomeDetails?.annual?.income?.length > 0) {
        // // console.log("income details", incomeDetails?.annual);
        // console.log("trueeeeeeeeeeeee");
        let incDet = incomeDetails?.annual?.income;

        // console.log(
        //   "2006-2007 difference",
        //   ((incDet[14]?.totalRevenue - incDet[15]?.totalRevenue) /
        //     incDet[16 - 1]?.totalRevenue) *
        //     100
        // );
        let temp = [];
        let i = incDet?.length - 1;
        while (i > 0) {
          // console.log("i", i, incDet[i]?.fiscalYear, incDet[i - 1]?.fiscalYear);
          temp.push({
            fiscalPeriod: `${incDet[i - 1]?.fiscalYear} `,
            revenueGrowth:
              ((incDet[i - 1]?.totalRevenue - incDet[i]?.totalRevenue) /
                incDet[i]?.totalRevenue) *
              100,
            operatingExpenseGrowth:
              ((incDet[i - 1]?.operatingExpense - incDet[i]?.operatingExpense) /
                incDet[i]?.operatingExpense) *
              100,
          });

          i = i - 1;
        }
        // console.log("lat Arr", temp);

        setTP(temp.map((t) => t?.fiscalPeriod));
        setRG(temp.map((t) => t?.revenueGrowth.toFixed(2)));
        setOpExG(temp.map((t) => t?.operatingExpenseGrowth.toFixed(2)));

        // // console.log("data>", temp);
        setGrowthData(temp);
      }
    }
    // console.log("changed", financialPeriod, incomeDetails);
  }, [incomeDetails, financialPeriod]);

  var options = {
    series: [
      {
        name: "Revenue Growth",
        data: revenueGrowth,
      },
      {
        name: "opEx Growth",
        data: opExpenseGrowth,
      },
    ],
    chart: {
      type: "line",
      height: 1400,
      background: "transparent",
      toolbar: {
        show: true,

        tools: {
          download: true,
          selection: window?.screen?.width > 600 ? true : false,
          zoom: window?.screen?.width > 600 ? true : false,
          zoomin: window?.screen?.width > 600 ? true : false,
          zoomout: window?.screen?.width > 600 ? true : false,
          pan: window?.screen?.width > 600 ? true : false,
          reset: window?.screen?.width > 600 ? true : false,
        },
        export: {
          csv: {
            filename: financialPeriod + " -growth",
            columnDelimiter: ",",
            headerCategory: "Financial Period",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: financialPeriod + " -growth",
          },
          png: {
            filename: financialPeriod + " -growth",
          },
        },
      },
    },
    colors: ["#29d293", "#fcc432"],

    stroke: {
      curve: "smooth",
      width: window?.screen?.width > 600 ? 5 : 3,
      lineCap: "butt",
      colors: ["#29d293", "#fcc432"],
      // OR provide an array
      // curve: ["smooth", "straight", "stepline"],
    },
    //   plotOptions: {
    //     bar: {
    //       horizontal: false,
    //       columnWidth: "75%",
    //       endingShape: "rounded",
    //     },
    //   },
    dataLabels: {
      enabled: false,
    },
    // stroke: {
    //   show: true,
    //   width: 2,
    //   colors: ["transparent"],
    // },
    legend: {
      show: true,
      showForSingleSeries: false,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: "top",
      horizontalAlign: "center",
      floating: false,
      fontSize: window?.screen?.width > 600 ? "14px" : "10px",
      fontFamily: "public sans",
      fontWeight: 400,
      labels: {
        useSeriesColors: true,
      },

      itemMargin: {
        horizontal: 5,
        vertical: 5,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    grid: {
      show: true,
      borderColor: mode == "light" ? "#d9d9d999" : "#d9d9d955",
      row: {},
      xaxis: {
        lines: {
          show: false,
        },
        position: "top",
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    theme: {
      mode: mode,
      //   palette: "palette5",
    },
    xaxis: {
      lines: {
        show: false, //or just here to disable only y axis
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
      // axisBorder: {
      //   show: true,
      //   color: "#78909C",
      //   height: 1,
      //   width: "100%",
      //   offsetX: 0,
      //   offsetY: 0,
      // },
      // axisTicks: {
      //   show: true,
      //   borderType: "solid",
      //   color: "#78909C",
      //   height: 6,
      //   offsetX: 0,
      //   offsetY: 0,
      // },
      categories: timePeriods,
      labels: {
        show: true,
        rotate: -50,
        rotateAlways: window?.screen?.width > 768 ? false : true,
        hideOverlappingLabels: true,
        showDuplicates: false,
        trim: false,
        maxHeight: 120,
        style: {
          color: new Array(timePeriods?.length)?.fill("#ff0000"),
          fontSize: "10px",
          fontFamily: "public sans",
          fontWeight: 400,
          cssClass: "apexcharts-xaxis-label",
        },
        offsetX: 0,
        offsetY: 0,
      },
    },
    yaxis: {
      tickAmount: 10,
      title: {
        text: "",
      },
      labels: {
        formatter: function (value) {
          return numFormatter(value.toFixed(0)) + "%  ";
        },
        style: {
          colors: [],
          fontSize: "10px",
          fontFamily: "public sans",
          fontWeight: 400,
          cssClass: "apexcharts-yaxis-label",
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return numFormatter(val) + "%";
        },
      },
    },
  };

  //   var options = {
  //     series: [
  //       {
  //         name: "Revenues",
  //         data: revenues,
  //       },
  //       {
  //         name: "Operating Incomes",
  //         data: operatingIncomes,
  //       },
  //       {
  //         name: "Gross Profit",
  //         data: grossProfit,
  //       },
  //     ],
  //     chart: {
  //       height: 350,
  //       type: "line",
  //       zoom: {
  //         enabled: false,
  //       },
  //     },
  //     dataLabels: {
  //       enabled: false,
  //     },
  //     stroke: {
  //       curve: "straight",
  //     },
  //     title: {
  //       text: "Product Trends by Month",
  //       align: "left",
  //     },
  //     grid: {
  //       row: {
  //         colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
  //         opacity: 0.5,
  //       },
  //     },
  //     xaxis: {
  //       categories: timePeriods,
  //     },
  //   };
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 12,
      fontFamily: "public sans",
      fontWeight: 300,
    },
  }));

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      backgroundColor: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 12,
      fontWeight: 300,
      fontFamily: "public sans",
    },
  }));
  const [chartDescription, x] = useState(
    "Year over Year Growth in Revenue and Operating Expenses."
  );
  return (
    <div>
      <Box
        sx={{
          fontFamily: "public sans",
          fontSize: "2rem",
          color: "fontPrimaryColor.main",
        }}
        className="chart__title"
      >
        Growth
      </Box>
      {dataView ? (
        <Box
          sx={{
            minWidth: "300px",
            marginLeft: "50%",
            transform: "translateX(-50%)",
          }}
          onClick={() => console.log("option.series", options?.series)}
        >
          <TableContainer component={Paper}>
            <Table
              sx={{
                minWidth: 50,
                fontFamily: "public sans",
              }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead
                sx={{
                  backgroundColor: "bgSecondary.main",
                  color: "fontSecondaryColor.main",
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: "bgSecondary.main",
                  }}
                >
                  <StyledTableCell
                    sx={{
                      color: "fontPrimaryColor.main",
                    }}
                  >
                    Financial Period
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      color: "fontPrimaryColor.main",
                    }}
                    align="right"
                  >
                    Revenue Growth(%)
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      color: "fontPrimaryColor.main",
                    }}
                    align="right"
                  >
                    Operating Expenses Growth(%){" "}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {new Array(timePeriods?.length).fill("1").map((row, i) => (
                  <TableRow
                    key={timePeriods[i]}
                    sx={{
                      backgroundColor: "bgPrimary.main",
                      boxShadow:
                        mode == "dark"
                          ? "#888 0px 0px 0px 1px"
                          : "#e6e6e6 0px 0px 0px 1px",
                    }}
                  >
                    <StyledTableCell
                      sx={{
                        color: "fontSecondaryColor.main",
                        borderBottom: "none",
                      }}
                      component="th"
                      scope="row"
                    >
                      {timePeriods[i]}
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{
                        color: "fontSecondaryColor.main",
                        borderBottom: "none",
                      }}
                      align="right"
                    >
                      {numFormatter(options?.series[0]?.data[i])}
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{
                        color: "fontSecondaryColor.main",
                        borderBottom: "none",
                      }}
                      align="right"
                    >
                      {" "}
                      {numFormatter(options?.series[1]?.data[i])}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <Chart
          options={options}
          series={options?.series}
          type="line"
          height={window?.screen?.width > 600 ? "200%" : "150%"}
          width="100%"
        />
      )}

      <Box className="chart__bottom__options__bar" sx={{ gap: "10px" }}>
        <Box
          className="showChartInfoBtn"
          sx={{ backgroundColor: "bgSecondary.main", borderRadius: "50%" }}
        >
          {mode == "dark" ? (
            <LightTooltip title={chartDescription} arrow>
              <Box>
                <QuestionMarkIcon
                  sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
                />
              </Box>
            </LightTooltip>
          ) : (
            <BootstrapTooltip title={chartDescription} arrow>
              <QuestionMarkIcon
                sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
              />
            </BootstrapTooltip>
          )}
        </Box>
        <Box onClick={() => setDataView(!dataView)}>
          <IconButton sx={{ backgroundColor: "bgSecondary.main" }}>
            <ViewListIcon
              sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
            />
          </IconButton>
        </Box>
      </Box>
    </div>
  );
};

export default GrowthChart;
function numFormatter(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num > 1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num > 100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num < 900 && num > 0) {
    return num; // if value < 1000, nothing to do
  } else if (num < -999 && num > -1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num < -1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num < -100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num < -1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num > -900) {
    return num; // if value < 1000, nothing to do
  }
}
